import { workList, workDetail } from '@/api/task'
import { formatDate } from '@/utils'

const state = {
  // 任务列表
  queryForm: {
    keyword: '',
    company_id: '',
    time: [formatDate(new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '01')), formatDate(new Date())],
    start_day: '',
    end_day: ''
  },
  pages: {
    pageSize: 10,
    page: 1,
    total: 0
  },
  tableData: [],
  // 任务详情
  detailQuery: {
    work_number: '',
    pay_status: ''
  },
  detailPages: {
    pageSize: 10,
    page: 1,
    total: 0
  },
  tableList: [],
  detailInfo: null
}
const getters = {
  queryForm: state => state.queryForm,
  pages: state => state.pages,
  tableData: state => state.tableData,
  tableList: state => state.tableList,
  detailQuery: state => state.detailQuery,
  detailPages: state => state.detailPages,
  detailInfo: state => state.detailInfo
}
const mutations = {
  save: (state, payload) => {
    Object.keys(payload).forEach(e => {
      if (Object.prototype.toString.call(state[e]) === '[object Object]') {
        state[e] = {
          ...state[e],
          ...payload[e]
        }
      } else {
        state[e] = payload[e]
      }
    })
  }
}
const actions = {
  // 任务列表
  workListFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const { code, data } = await workList(params)
      if (code === 200) {
        commit('save', {
          tableData: data.data,
          pages: {
            ...state.pages,
            total: data.total
          }
        })
        resolve()
      }
    })
  },
  // 任务详情
  workDetailFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const { code, data } = await workDetail(params)
      if (code === 200) {
        commit('save', {
          tableList: data.list.data,
          detailInfo: data.info,
          detailPages: {
            ...state.detailPages,
            total: data.list.total
          }
        })
        resolve()
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

